// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"O6-z"};